import { observer } from "mobx-react";
import React from "react";
import { UserProfileQuizAnswerStore } from "stores/UserProfileStore";
import { computed } from "mobx";
import { Column, GroupRow, Row } from "./styles";
import SimpleField from "components/SimpleField";

type Props = {
  userId?: number;
  quizId: number;
};

@observer
class QuizAnswer extends React.Component<Props> {
  @computed get answers() {
    return this.chunckArrayInGroups(UserProfileQuizAnswerStore.items, 2);
  }

  chunckArrayInGroups = (arr: any, size: number) => {
    var chunk = [];
    var i; // declara array vacio e indice de for
    for (
      i = 0;
      i <= arr.length;
      i += size // loop que recorre el array
    )
      chunk.push(arr.slice(i, i + size)); // push al array el tramo desde el indice del loop hasta el valor size + el indicador
    return chunk;
  };

  async componentDidMount() {
    const { userId, quizId } = this.props;
    await UserProfileQuizAnswerStore.fetch(userId, quizId);
  }

  async componentDidUpdate(prevProps: Props) {
    const { userId, quizId } = this.props;
    if (prevProps.quizId !== quizId) {
      await UserProfileQuizAnswerStore.fetch(userId, quizId);
    }
  }

  render() {
    return (
      <GroupRow>
        <Column>
          {this.answers?.map((items, index) => (
            <Row key={index}>
              {items?.map((item: any, index: number) => (
                <Column key={index}>
                  <SimpleField label={item.title} value={item.answer} />
                </Column>
              ))}
            </Row>
          ))}
        </Column>
      </GroupRow>
    );
  }
}

export default QuizAnswer;
